"use strict";
exports.__esModule = true;
exports.BusinessLogicExceptionErrorCode = void 0;
var BusinessLogicExceptionErrorCode;
(function (BusinessLogicExceptionErrorCode) {
    BusinessLogicExceptionErrorCode["B_PAYMENT_GENERIC_DECLINE"] = "B10012";
    BusinessLogicExceptionErrorCode["B_INSUFFICIENT_FUNDS"] = "B10013";
    BusinessLogicExceptionErrorCode["B_PAYMENT_UPDATE_CARD"] = "B10014";
    BusinessLogicExceptionErrorCode["B_PAYMENT_DEFAULT_FAILURE"] = "B10015";
    BusinessLogicExceptionErrorCode["B_UNSUPPORTED_BILL_STATUS_OFFER"] = "B10016";
    BusinessLogicExceptionErrorCode["B_UNCAUGHT_EXCEPTION"] = "B10002";
})(BusinessLogicExceptionErrorCode = exports.BusinessLogicExceptionErrorCode || (exports.BusinessLogicExceptionErrorCode = {}));
